<template>
    <div class="md-layout">
        <notifications></notifications>
        <!-- Listagem dos parametros -->
        <div class="md-layout-item md-size-100">
            <md-card v-if="!filterLoading">
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>local_offer</md-icon>
                    </div>
                    <h4 class="title"></h4>
                </md-card-header>

                <md-card-content>
                    <md-table
                        :value="tableData"
                        :md-sort.sync="currentSort"
                        :md-sort-order.sync="currentSortOrder"
                        :md-sort-fn="orderByCustom"
                        @md-selected="onSelectSolicitation"
                        class="paginated-table table-striped table-hover table-height"
                    >
                        <md-table-toolbar>
                            <div class="md-toolbar-section-start">
                                <h1 class="md-title">
                                    Parametros de Sortimento.
                                </h1>
                            </div>
                        </md-table-toolbar>

                        <md-table-toolbar
                            class="mt-2"
                            slot="md-table-alternate-header"
                            slot-scope="{}"
                        >
                            <div class="md-toolbar-section-start">
                                <md-button
                                    class="md-simple md-primary"
                                    @click="editMultiParamModal()"
                                    :disabled="canEdit"
                                >
                                    <md-icon>check</md-icon>
                                    Editar parametros
                                </md-button>
                            </div>
                        </md-table-toolbar>

                        <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                            md-selectable="multiple"
                            md-auto-select
                            @mouseenter="actionVisible = item.id"
                            @mouseleave="actionVisible = null"
                        >
                            <md-table-cell
                                v-for="column in visibleColumns"
                                :md-label="columnNames[column]"
                                :md-sort-by="column"
                                :key="column"
                                :title="item[column]"
                            >
                                <div v-if="column === 'selected_item'">
                                    <v-checkbox
                                        @change="
                                            parameter_selected($event, item)
                                        "
                                    >
                                    </v-checkbox>
                                </div>
                                <div v-else>
                                    <span
                                        v-if="newProduct(column, item)"
                                        class="new_product"
                                    >
                                        <img
                                            class="img_new_product"
                                            src="/img/new-product.png"
                                            alt="Novo Produto"
                                            title="Novo Produto"
                                        />
                                    </span>

                                    {{ item[column] }}
                                </div>
                            </md-table-cell>
                            <md-table-cell class="td-actions">
                                <div v-if="actionVisible == item.id">
                                    <md-button
                                        class="md-just-icon md-primary md-simple"
                                        @click="openSingleModal(item)"
                                        :disabled="canEdit"
                                    >
                                        <md-icon>edit</md-icon>
                                    </md-button>
                                </div>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Mostrando
                            {{ this.tableData.length }} itens de um total de
                            {{ total }}.
                        </p>
                    </div>
                    <div>
                        <md-button
                            @click="applyChanges()"
                            class="md-primary"
                            type="submit"
                            :disabled="savePress"
                        >
                            Salvar
                        </md-button>
                    </div>
                </md-card-actions>
            </md-card>
        </div>

        <form @submit.prevent="saveChange()">
            <modal v-if="editModal" @close="editCancel()">
                <template slot="header">
                    <h4 class="modal-title">{{ editModalTitle }}</h4>
                    <md-button
                        class="md-simple md-just-icon md-round modal-default-button"
                        @click="editCancel()"
                    >
                        <md-icon>clear</md-icon>
                    </md-button>
                </template>

                <template slot="body">
                    <div class="md-layout">
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            v-for="field in editableFields"
                            :key="field"
                        >
                            <md-field v-if="field !== 'id'">
                                <label>{{ columnNames[field] }}</label>
                                <md-input
                                    v-model="editModalModel[field]"
                                    :type="fieldTypes[field]"
                                    min="0"
                                    required
                                ></md-input>
                            </md-field>
                        </div>
                    </div>
                </template>

                <template slot="footer">
                    <md-button
                        class="md-danger space-button"
                        @click="editCancel()"
                    >
                        Cancelar
                    </md-button>
                    <md-button class="md-primary" type="submit">
                        Confirmar
                    </md-button>
                </template>
            </modal>
        </form>
    </div>
</template>

<script>
import Vue from 'vue'
import { AssortmentParameter as Model } from '@/models/assortmentparameter.model'
import { Modal } from '@/components'
import { mapState, mapActions } from 'vuex'
import Notifications from '@/components/NotificationPlugin'
import CustomSort from '@/mixins/CustomSort'

Vue.use(Notifications)

export default {
    async created() {
        const amplitudeId = this.$route.params.branch
        const token = this.$route.query.token

        await this.generateToken({ token })

        if (this.tokenRequestError) {
            this.$router.push('/')
            return
        }

        await this.readAssortmentParameter({ branch: amplitudeId })
        await this._readAmplitudeById(amplitudeId)

        if (this.requestError) {
            this.$router.push('/')
            return
        }

        this.tableData.forEach(i => {
            if (i.is_selected) {
                this.selectedItens.push(i)
            }
        })

        this.changeShowColumns(this.tableData)
        this.setBranch(amplitudeId)
    },

    components: {
        Modal
    },

    computed: {
        ...mapState({
            amplitude: state => state['restocking'].amplitude,
            queriedData: state => state['assortmentparameter'].data,
            filterLoading: state => state['assortmentparameter'].filterLoading,
            requestError: state => state['assortmentparameter'].requestError,
            tokenRequestError: state => state['auth'].requestError
        }),
        tableData() {
            const data = this.queriedData.map(item => {
                return {
                    ...item,
                    id: item.id,
                    product_external_id: item.product.external_id,
                    product_name: item.product.name,
                    coverage: item.coverage,
                    stack_items: item.stack_items,
                    showcase_items: item.showcase_items,
                    stock_max: item.stock_max,
                    is_restocking_new: item.is_restocking_new
                }
            })
            return this.orderByCustom(data)
        },

        visibleColumns() {
            let columns = []

            Object.keys(this.showColumns).forEach(key => {
                if (this.showColumns[key]) columns.push(key)
            })
            return columns
        },

        to() {
            if (this.tableData.length > 0)
                return this.tableData[this.tableData.length - 1].id
            else return 0
        },

        from() {
            if (this.tableData.length > 0) return this.tableData[0].id
            else return 0
        },

        total() {
            return this.tableData.length
        }
    },

    data() {
        return {
            branch: '',
            showColumns: [],
            selectedItems: [],
            multiAtt: [],
            modalEdit: '',
            actionVisible: null,
            currentSort: 'ranking_position',
            currentSortOrder: 'asc',
            columnNames: Model.fieldNames,
            columnsModal: false,
            selectedItens: [],
            editModalTitle: '',
            editModalModel: new Model(),
            editModal: false,
            editableFields: Object.keys(Model.editableFields).filter(
                item =>
                    [
                        'selected_item',
                        'product_external_id',
                        'product_name',
                        'is_restocking_new'
                    ].indexOf(item) == -1
            ),
            fieldTypes: Model.fieldTypes,
            savePress: true,
            canEdit: false
        }
    },
    mixins: [CustomSort],
    methods: {
        ...mapActions('assortmentparameter', {
            _readAssortmentParameter: 'readAssortmentParameter',
            _createSolicitation: 'createSolicitation'
        }),
        ...mapActions('restocking', {
            _readAmplitudeById: 'readAmplitudeById'
        }),
        ...mapActions('auth', {
            _generateToken: 'generateToken'
        }),

        async readAssortmentParameter({ token, branch }) {
            await this._readAssortmentParameter({ token, branch })
        },

        async generateToken({ token }) {
            await this._generateToken({ token })
        },

        changeShowColumns(value) {
            if (value.length > 0) {
                this.showColumns = Model.visibleFields
            }
        },

        editMultiParamModal() {
            if (this.selectedItems > 0) {
                this.editModalTitle = 'Editando vários itens.'
                this.editModalModel = {
                    ...new Model()
                }
            }
            this.editModal = true
            this.modalEdit = 'multiParam'
        },

        setBranch(branch) {
            this.branch = branch
        },

        onSelectSolicitation(items) {
            this.selectedItems = items
        },

        openSingleModal(item) {
            if (item) {
                this.editModalTitle = 'Editando'
                this.editModalModel = {
                    ...new Model(),
                    ...item
                }
            }
            this.editModal = true
            this.modalEdit = 'singleParam'
        },

        editCancel() {
            this.editModal = false
            this.editModalModel = new Model()
        },

        saveChange() {
            if (this.modalEdit === 'singleParam') {
                if (this.editModalModel.id) {
                    this.tableData.filter(item => {
                        if (item.id === this.editModalModel.id) {
                            item.coverage = this.editModalModel.coverage
                            item.stack_items = this.editModalModel.stack_items
                            item.showcase_items = this.editModalModel.showcase_items
                            item.stock_max = this.editModalModel.stock_max
                            item.edit_item = true
                        }
                    })
                }
            } else if (this.modalEdit === 'multiParam') {
                this.selectedItems = this.selectedItems.forEach(item => {
                    item.coverage = this.editModalModel.coverage
                    item.stack_items = this.editModalModel.stack_items
                    item.showcase_items = this.editModalModel.showcase_items
                    item.stock_max = this.editModalModel.stock_max
                    item.edit_item = true
                })
            }
            this.editModal = false
            this.savePress = false
            this.editModalModel = new Model()
        },

        async applyChanges() {
            let editError
            let request_body = []
            let user = parseInt(localStorage.user_id)
            this.savePress = true
            this.canEdit = true

            this.tableData.filter(item => {
                if (item.edit_item) {
                    request_body.push(item)
                }
            })

            if (request_body.length > 0) {
                editError = await this._createSolicitation({
                    user: user,
                    request_body: request_body,
                    branch: this.amplitude.branch
                })
            }

            if (editError) {
                this.savePress = false
                this.canEdit = false
                this.$notify({
                    message: 'Erro ao editar os parametros.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
            } else {
                this.$notify({
                    message:
                        'Parâmetros editados com sucesso. Você pode fechar essa tela.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'success'
                })
            }
        },
        newProduct(column, item) {
            return (
                column === 'product_external_id' &&
                item['is_restocking_new'] === true
            )
        }
    }
}
</script>

<style lang="css" scoped>
.modal-wrapper .md-checkbox {
    display: flex !important;
}

.space-button {
    margin-right: 10px !important;
}

.table-height {
    max-height: 70vh;
}

tr {
    position: relative;
}

.new_product {
    position: absolute;
    animation: animateProduct 2s linear infinite;
    overflow: hidden;
    top: 1px;
    right: 2px;
}

@media (max-width: 1400px) {
    .new_product {
        animation: none;

    }

    .img_new_product {
        width: 2rem;
    }
}

@media (max-width: 1360px) {
    .new_product {
        animation: none;

        top: 1px;
        right: 2px;
    }

    .img_new_product {
        width: 1.8rem;
    }
}

@keyframes animateProduct {
    0% {
        opacity: 1;
    }
    25% {
        opacity: 0.5;
    }

    50% {
        opacity: 0.25;
    }

    100% {
        opacity: 0;
    }
}
</style>
